import React from 'react';

export default function BioPixelLogo() {
  const imagePriorityProps = { fetchpriority: 'low' } as React.ImgHTMLAttributes<HTMLImageElement>;

  return (
    <div className="biopixel-logo">
      <a href={"https://biopixel.tv/"}>
        <img src="/images/logo.webp" alt="BioPixel" width="100%" decoding="async" {...imagePriorityProps} />
      </a>
    </div>
  )
}